import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import BlogPost from "./components/blog/BlogPost";
import BlogDetail from "./components/blog/BlogDetail";
import ManufacturingPage from "./pages/ManufacturingPage";
import LabForCollege from "./pages/LabForCollege";
import LearningPage from "./pages/LearningPage";
import ContactPage from "./pages/ContactPage";
import MasonaryPage from "./pages/MasonaryPage";
import CareerPage from "./pages/CareerPage";

function App() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const originalHtmlOverscroll = html.style.overscrollBehavior;
    const originalBodyOverscroll = body.style.overscrollBehavior;

    html.style.overscrollBehavior = "none";
    body.style.overscrollBehavior = "none";

    return () => {
      html.style.overscrollBehavior = originalHtmlOverscroll;
      body.style.overscrollBehavior = originalBodyOverscroll;
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog-post" element={<BlogPost />} />
            <Route path="/blog/:blogId" element={<BlogDetail />} />
            <Route path="/tag/:blogId" element={<BlogDetail />} />
            <Route path="/smart-manufacturing" element={<ManufacturingPage />} />
            <Route path="/lab-for-college" element={<LabForCollege />} />
            <Route path="/lab-for-school" element={<LearningPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/masonary" element={<MasonaryPage />} />
            <Route path="/career" element={<CareerPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
